export default () => {
    const diaInits = document.querySelectorAll(".grid-frame")
    diaInits.forEach(n => {
        const $targetParents = document.querySelectorAll('.path-dot-wrapp');
        const $wrapper = document.querySelector('.svg-dots_desc');
        const $targetTextItems = document.querySelectorAll('[data-point-path]');

        const $targetParentsMob = document.querySelectorAll('.path-dot-wrapp-mob');
        const $wrapperMob = document.querySelector('.svg-dots_mob');
        const $targetTextPointsMob = document.querySelectorAll('[data-point-mob]');

        const checkIsMouseOverElMob = (el, clientX, clientY) => {
        let boxmob = el.getBoundingClientRect();
        return clientX > boxmob.left && clientX < boxmob.right && clientY > boxmob.top && clientY < boxmob.bottom;
        }

        document.addEventListener('mousemove', e => {

        if (!checkIsMouseOverElMob($wrapperMob, e.clientX, e.clientY)) {
            return
        }

        $targetParentsMob.forEach(($par) => {
            const $targetItemsMob = $par.querySelectorAll('.path-dot-wrapp-mob .path-dot');
            const dataIdMob = $par.dataset.mobFindId;

            const isFoundMob = Array.from($targetItemsMob).findIndex($item => {
            return checkIsMouseOverElMob($item, e.clientX, e.clientY);
            });

            const $targetTextPoint = Array.from($targetTextPointsMob).find(textPoint => {
            return textPoint.dataset.pointMob == dataIdMob;
            });

            if (isFoundMob !== -1) {
            $par.classList.add('_current');
            $targetTextPoint.style.display = 'block';
            }
            else {
            $par.classList.remove('_current');
            $targetTextPoint.style.display = '';
            }
        })

        })

        const checkIsMouseOverEl = (el, clientX, clientY) => {
        let box = el.getBoundingClientRect();
        return clientX > box.left && clientX < box.right && clientY > box.top && clientY < box.bottom;
        }

        document.addEventListener('mousemove', e => {

        if (!checkIsMouseOverEl($wrapper, e.clientX, e.clientY)) {
            return
        }

        $targetParents.forEach(($parent) => {
            const $targetItems = $parent.querySelectorAll('.path-dot-wrapp .path-dot');
            const dataId = $parent.dataset.findId;

            const isFound = Array.from($targetItems).findIndex($item => {
            return checkIsMouseOverEl($item, e.clientX, e.clientY);
            });

            const $targetTextItem = Array.from($targetTextItems).find(textItem => {
            return textItem.dataset.pointPath == dataId;
            });

            if (isFound !== -1) {
            $parent.classList.add('_current');
            $targetTextItem.style.display = 'block';
            }
            else {
            $parent.classList.remove('_current');
            $targetTextItem.style.display = '';
            }
        })

        })
    })

}
